import React from 'react';
import { SwitchField } from 'components/form';
import { useFormContext } from 'react-hook-form';

import { VOFilters } from '../../types';

export const ClosedDeals = () => {
  const { control } = useFormContext<VOFilters>();

  return <SwitchField control={control} name="CLOSED_DEALS.isIncludeClosedDeals" label="Include closed deals" />;
};
